// extracted by mini-css-extract-plugin
export default {"card5":"NMoFgPUv","image":"ozIwx80l","content":"n0P00p9P","quote":"KVl7uF8F"};